import React from 'react'
import styled from 'styled-components'
import Text from '../Text/Text'
import { getConfigFor } from '../../utils/configService'
import { SPLIT_FEATURES } from '../../utils/constants'
import { DEFAULT_BENEFIT_CONFIGS } from '../../utils/constants/general'

const TableNote = styled.div`
  display: flex;
`

const NoteTitle = styled.div`
  text-align: left;
  min-width: 4rem;
  margin-right: 0.25rem;
`

const NoteItem = styled.div`
  text-align: left;
`

const FormattedBenefitCriterion = ({ criterion }) => (
  <Text as="p" color="#696969">
    {criterion?.prefix && criterion.prefix}
    {criterion?.format && <s>{criterion.format}</s>}
    {criterion?.suffix}
  </Text>
)

const BenefitNote = () => {
  const { configuration: dcBenefitConfigs } = getConfigFor(
    SPLIT_FEATURES.DC_FREE_TRIAL_BENEFITS,
    {
      defaultConfiguration: DEFAULT_BENEFIT_CONFIGS,
    }
  )
  const { criteria, criteriaNote } = dcBenefitConfigs
  return (
    <TableNote>
      {criteriaNote && (
        <NoteTitle>
          <Text color="#696969">{criteriaNote}</Text>
        </NoteTitle>
      )}
      <NoteItem>
        {criteria.map((criterion, index) => (
          <FormattedBenefitCriterion
            criterion={criterion}
            key={`criterion-${index}`}
          />
        ))}
      </NoteItem>
    </TableNote>
  )
}

export default BenefitNote
